export default "__VITE_ASSET__amsbDDP2__"